import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import X46MK2InteriorConfiguratorImage from './X46MK2InteriorConfiguratorImage'
import ConfiguratorOption from './../ConfiguratorOption'
import RadioGroup from './../RadioGroup'
import MaterialSelector from './../MaterialSelector'
import { withTranslation, Trans } from 'react-i18next'
import { interiorView11ImageOptions } from './views/InteriorView11'

class X46MK2StarboardAftCabin extends Component {
  constructor (props) {
    super(props)
    this.handleOptionsChange = this.handleOptionsChange.bind(this)
    this.handleFabricChange = this.handleFabricChange.bind(this)
  }

  handleOptionsChange (newValue) {
    const configuration = this.props.configuration
    configuration.StarboardAftCabinOptions = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  handleFabricChange (newValue) {
    const configuration = this.props.configuration
    configuration.FabricCabins = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

  render () {
    const image = (
      <X46MK2InteriorConfiguratorImage
        boat='X46MK2'
        configuration={this.props.configuration}
        options={interiorView11ImageOptions}
      />
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='Starboard aft cabin' />
          </h1>
          <p>
            <Trans defaults='Standard of the X4<sup>6</sup> is double berth in both aft cabins.' />
          </p>
          <p>
            <Trans defaults='Optional is a split berth in port side aft cabin and freeboard hung sea berths in both cabins (sea berths are not shown on this rendering. Furthermore, please note that sea berths are not an option if upper shelves are selected).' />
          </p>
          <p>
            <Trans defaults='For extra storage, upper shelves in both aft cabins is an option.' />
          </p>
          <p>
            <Trans defaults='On this image, the cabin is shown with ambient lighting fitted in hull deck joint.' />
          </p>

          <h2>
            <Trans defaults='Furniture' />
          </h2>
          <RadioGroup
            options={this.props.starboardAftCabinOptions}
            value={this.props.configuration.StarboardAftCabinOptions}
            onChange={this.handleOptionsChange}
          />

          <h2>
            <Trans defaults='Fabric cabins' />
          </h2>
          <MaterialSelector
            options={this.props.fabricCabinsOptions || this.props.fabricOptions}
            label={this.props.configuration.FabricCabins.label}
            value={this.props.configuration.FabricCabins}
            onChange={this.handleFabricChange}
          />
        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(X46MK2StarboardAftCabin)



// WEBPACK FOOTER //
// ./src/X46MK2/X46MK2StarboardAftCabin.js